<div class="containerlist">
  <main>
    <img alt="LogoImg">
    <h1 class="titlecls text-center"> {{title | uppercase}} </h1>
    <div class="theme">
      <app-theme-switcher></app-theme-switcher>
    </div>
    <div class="tour-buttons ps-4 hide-on-small" *ngIf="role != 'Unauthorized' && showTourButton">
      <button mat-button (click)="startPageTour()" matTooltip="Start Tour" data-tour="tour-button"
        class="tour-start-btn" aria-label="Start guided tour">
        <mat-icon class="material-icons-outlined">help_outline</mat-icon>
      </button>
    </div>
    <div class="dropdownlocale hide-on-small" *ngIf="checkAffiliate.length>0">
      <app-locale-switcher></app-locale-switcher>
    </div>
    <div class="user_acc" data-tour="user-profile">
      <button mat-button [matMenuTriggerFor]="menu" (click)="this.reference()">
        <mat-icon class="menu_profile_icon material-icons-outlined">person</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <mat-card class="pf-bg">
          <div class="profile-div">
            <img class="profile-picture" src="../../../../assets/images/k_profile.jpg" alt="profile-picture"
              *ngIf="this.graphapiservice.getImageNotFound()">
            <img *ngIf="!this.graphapiservice.getImageNotFound()" class="profile-picture"
              [src]="this.graphapiservice.getProfilePhoto()" alt="userProfilePic">
            <h4 class="nm-align"> {{userName}}
              <p>
                {{Company}}
              </p>
            </h4>
          </div>
        </mat-card>
        <mat-accordion class="profile-accordion">
          <mat-expansion-panel [expanded]="false" hideToggle (click)="handleRef($event)"
            (closed)="refPanelOpenState.set(!isRefPanelOpen)">
            <mat-expansion-panel-header class="disable_ripple">
              <mat-panel-title>
                <h4 class="panel-title">{{"header.References"|translate}} <span
                    *ngIf="refereceDocsList.length>0">({{refereceDocsList.length}})</span><span
                    *ngIf="refereceDocsList.length<=0">(0)</span></h4>
              </mat-panel-title>
              <span>
                <mat-icon class="primary-text-color">{{refPanelOpenState() ? 'remove' : 'add'}}</mat-icon>
              </span>
            </mat-expansion-panel-header>
            <div>
              @for( item of refereceDocsList; track $index){
              <a class="panel-link" *ngIf="item.is_link == 'file'" (click)="download(item)">
                {{item.display_file_name}}
              </a>
              <a class="panel-link" *ngIf="item.is_link != 'file'" target="_blank" rel="noopener noreferrer"
                [href]="item.file_path">
                {{item.display_file_name}}
              </a><br>
              }
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        <div class="sign-out-text" (click)="logout()">
          {{"header.signout"|translate}}
        </div>
      </mat-menu>
    </div>
  </main>
  <div *ngIf="role != 'Unauthorized'">
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
      <div class="container-fluid">
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
          aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" #navbarNav id="navbarNav">
          <ul class="navbar-nav">
            <li class="nav-item">
              <a class="nav-link active" aria-current="page" aria-expanded="false" routerLink="/home"
                [routerLinkActive]="['active']" (click)="collapseNavbar();onAwayFromApprovals();" data-tour="navigation-menu">
                <h3 *ngIf="role != ''">{{ "header.home" | translate }}</h3>
                <h3 *ngIf="role === ''" style="visibility: hidden;">placeholder</h3>
              </a>
            </li>
            <li class="nav-item" *ngIf="role !== 'User' && role != ''">
              <a class="nav-link" routerLink="/approvals" aria-expanded="false" [routerLinkActive]="['active']"
                (click)="collapseNavbar();">
                <h3>{{"header.approvals" | translate }}</h3>
              </a>
            </li>
            <li class="nav-item" *ngIf="role != '' && counterMeasureAvailable && countermeasure_enabled">
              <a class="nav-link" routerLink="/countermeasures" aria-expanded="false" [routerLinkActive]="['active']"
                (click)="collapseNavbar();">
                <h3>{{"counterMeasure.counterMeasure" | translate }}</h3>
              </a>
            </li>
            <li class="nav-item" *ngIf="role == 'Admin' || role == 'ApproverAdmin'">
              <a class="nav-link" routerLink="/reports" aria-expanded="false" [routerLinkActive]="['active']"
                (click)="collapseNavbar();">
                <h3>{{"header.reports" | translate }}</h3>
              </a>
            </li>
            <li class="nav-item" *ngIf="role == 'Admin'">
              <a class="nav-link" aria-expanded="false" routerLink="/admin" [routerLinkActive]="['active']"
                (click)="collapseNavbar();onAwayFromApprovals();">
                <h3>{{"header.admin" | translate}}</h3>
              </a>
            </li>
            <li class="nav-item show-on-small">
              <div class="dropdownlocale" *ngIf="checkAffiliate.length>0">
                <app-locale-switcher></app-locale-switcher>
              </div>
            </li>
            <li class="nav-item ml-auto hide-on-small">
              <a class="nav-link wl-align">
                <h3 *ngIf="userName">{{"header.welcome" | translate}}, {{userName}}</h3>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</div>